import React from "react";
import { Icon } from "@iconify/react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./bank.scss";
import {
  AcceptTermsIcon,
  CreditCardIcon,
  DeleteIcon,
  EditIcon,
} from "../../../../assets";
import { Button } from "../../Button";
import { CustomCard } from "../../CustomCard";

export const BankCard = ({
  data,
  handleDelete,
  roleID,
  handleEditModal,
  handleAccept,
}) => {
  const {
    svc_bank_bank_name,
    svc_bank_account,
    svc_bank_routing_nbr,
    svc_bank_id,
    user_profile_name,
    iso_cntry_cde,
    svc_bank_swiftcode,
    bank_acct_holder_name,
    svc_bank_stipe_terms_yn,
    has_stripe_acct_yn,
  } = data;

  return (
    <CustomCard className="bankCard">
      <div
        className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="rounded-5 border-slate-300 align-items-center justify-content-center d-flex bankCard_creditCardIcon">
            <CreditCardIcon />
          </div>
          <div>
            <h6 className="card-title mb-0">{`${svc_bank_bank_name}:(${svc_bank_id})${user_profile_name}`}</h6>
            <small>#{svc_bank_id}</small>
          </div>
        </div>
        <DeleteIcon style={{ cursor: "pointer" }} onClick={handleDelete} />
      </div>

      <div className="row" style={{ rowGap: "18px" }}>
        <div className="col-6">
          <small>ACCOUNT HOLDER</small>
          <p className="mb-0">
            {bank_acct_holder_name || `${user_profile_name} (default)`}
          </p>
        </div>
        <div className="col-6">
          <small>ACCOUNT NO</small>
          <p className="mb-0">{svc_bank_account}</p>
        </div>
        <div className="col-6">
          <small>SWIFT CODE</small>
          <p className="mb-0">{svc_bank_swiftcode}</p>
        </div>
        <div className="col-6">
          <small>ROUTING NO</small>
          <p className="mb-0">{svc_bank_routing_nbr}</p>
        </div>
        <div className="col-6">
          <small>BANK COUNTRY</small>
          <p className="mb-0">{iso_cntry_cde}</p>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center !mt-3 gap-2">
        {roleID !== "3" && (
          <>
          <div className="flex items-center relative">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Edit Bank</Tooltip>}
            >
              <button onClick={() => handleEditModal(data)} className="w-[100px] h-[38px] absolute z-50"></button>
            </OverlayTrigger>
            <Button className="min-w-[100px]" variant="outline">
                <EditIcon />
                Edit
            </Button>
            </div>
            {(!svc_bank_stipe_terms_yn || svc_bank_stipe_terms_yn === "N") &&
              has_stripe_acct_yn === "Y" && (
                <Button className="w-full" variant="primary" onClick={handleAccept}><AcceptTermsIcon />  Accept Terms</Button>
              )}
          </>
        )}
      </div>
    </CustomCard>
  );
};
